import React, { createContext, useState, useEffect, useContext, useMemo } from 'react';
import { useFunFactsDataQuery } from '../hooks/useQueryHooks';
import { FunFactData } from './funfact_data'; // Import static data for fallback

const FunFactsDataContext = createContext();

export const FunFactsDataProvider = ({ children }) => {
    const { data, isLoading, error } = useFunFactsDataQuery();
    const [funFactsData, setFunFactsData] = useState(null);

    useEffect(() => {
        if (data) {
            console.log('FunFactsDataProvider: Data fetched successfully', data);
            setFunFactsData(data);
        } else if (error) {
            console.error('FunFactsDataProvider: Error fetching data, using fallback', error);
            setFunFactsData(FunFactData); // Use static data as fallback
        }
    }, [data, error]);

    // Use useMemo to memoize the context value
    const value = useMemo(() => ({
        funFactsData: funFactsData || FunFactData, // Use static data if API data is not available
        isLoading,
        error
    }), [funFactsData, isLoading, error]);

    console.log('FunFactsDataProvider rendering with:', value);

    useEffect(() => {
        if (funFactsData) {
            sessionStorage.setItem('funFactsData', JSON.stringify(funFactsData));
        }
    }, [funFactsData]);

    return (
        <FunFactsDataContext.Provider value={value}>
            {children}
        </FunFactsDataContext.Provider>
    );
};

export const useFunFactsData = () => {
    const context = useContext(FunFactsDataContext);
    if (context === undefined) {
        throw new Error('useFunFactsData must be used within a FunFactsDataProvider');
    }
    return context;
};
